import { render, staticRenderFns } from "./dataModification.vue?vue&type=template&id=f0f970f6&scoped=true&"
import script from "./dataModification.vue?vue&type=script&lang=js&"
export * from "./dataModification.vue?vue&type=script&lang=js&"
import style0 from "./dataModification.vue?vue&type=style&index=0&id=f0f970f6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f970f6",
  null
  
)

export default component.exports